import { useCallback, useMemo } from 'react';
import { useCurrentUser } from '../context/UserContext';
import {
  DEFAULT_CURRENCY,
  formatCurrency,
  getCurrencySymbol,
} from '../utils/currency';

// Reads the organisation-wide currency from the current user and exposes
// helpers for formatting money consistently across the app.
export function useCurrency() {
  const currentUser = useCurrentUser();
  const currency = currentUser?.company_currency || DEFAULT_CURRENCY;

  const format = useCallback(
    (value, options) => formatCurrency(value, currency, options),
    [currency]
  );

  const symbol = useMemo(() => getCurrencySymbol(currency), [currency]);

  return { currency, symbol, format };
}

export default useCurrency;
